import {
  TranslationCertificateMessages,
  CertificateMessages
} from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationCertificateMessages = {
  [CertificateMessages.activeText]: "Text"
};
